import { createAction, handleActions } from 'redux-actions';
import { remove, findIndex, concat, forEach } from 'lodash';
import { takeLatest } from 'redux-saga/effects';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, { createRequestActionTypes } from '../../lib/createRequestSaga';

// 수납함 상품 (복수개 가능) 저장 
const SET_USER_CART_PROD = 'usercart/SET_USER_CART_PROD';
// 수납 상품 삭제 
const REMOVE_USER_CART_PROD = 'usercart/REMOVE_USER_CART_PROD';
// 브랜드 기준 상품 전체 삭제 
const REMOVE_USER_CART_PROD_BRAND = 'usercart/REMOVE_USER_CART_PROD_BRAND';
// 상품 정보 업데이트 
const UPDATE_USER_CART_PROD_INFO = 'usercart/UPDATE_USER_CART_PROD_INFO';

// 장바구니 비우기 
const CLEAR_CART = 'usercart/CLEAR_CART';

// 코드 정보 초기화 
const CLEAR_CODE = 'usercart/CLEAR_CODE';

//장바구니에서 카트 상품 삭제 후 저장.
const SET_USER_CART_PROD_LIST = 'usercart/SET_USER_CART_PROD_LIST';

const SET_USER_REQ_RROD_LIST = 'usercart/SET_USER_REQ_RROD_LIST'

// 장바구니 Sync 
const [
    SYNC_CART,
    SYNC_CART_SUCCESS,
    SYNC_CART_FAILURE
] = createRequestActionTypes('usercart/SYNC_CART');

const [
    GET_CART,
    GET_CART_SUCCESS,
    GET_CART_FAILURE
] = createRequestActionTypes('usercart/GET_CART');

// Actions 
export const setUserCartProdsAction = createAction(SET_USER_CART_PROD);
export const removeUserCartProdAction = createAction(REMOVE_USER_CART_PROD);
export const removeUserCartProdBrandAction = createAction(REMOVE_USER_CART_PROD_BRAND);
export const updateUserCartProdInfoAction = createAction(UPDATE_USER_CART_PROD_INFO);
export const syncUserCartAction = createAction(SYNC_CART, (syncCartItem) => ({ syncCartItem }));
export const clearUserCartAction = createAction(CLEAR_CART);
export const getUserCartAction = createAction(GET_CART);
export const clearUserCartCodeAction = createAction(CLEAR_CODE);
export const setUserCartProdsListAction = createAction(SET_USER_CART_PROD_LIST);
export const setUserReqProdsListAction = createAction(SET_USER_REQ_RROD_LIST);

// Make Saga I/F
const syncUserCartSaga = createRequestSaga(SYNC_CART, userAPI.syncCart);
const getUserCartSaga = createRequestSaga(GET_CART, userAPI.getCart);

/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    synccode: null,
    getcode: null,
    updateStatus: false,
    cartProdList: [],
    reqProdList:[],
};

export function* userCartSaga() {
    yield takeLatest(SYNC_CART, syncUserCartSaga);
    yield takeLatest(GET_CART, getUserCartSaga);
}

/**
 * 리덕스 액션 연결 
 */
const userCartReducer = handleActions(
    {
        [CLEAR_CODE]: (state) => {
            return ({
                ...state,
                getcode: null,
                synccode: null
            })
        },
        [CLEAR_CART]: (state) => {
            return ({
                ...state,
                cartProdList: []
            })
        },
        [GET_CART_SUCCESS]: (state, { payload }) => {

            // 현재 있는 data와 서버로 부터 내려온 data를 비교하여 재설정 
            forEach(payload.data, (curitem, index) => {

                // 로컬에 같은 아이템이 존재하는지 확인
                let idx = findIndex(state.cartProdList, (targetobj, index) => {
                    return (targetobj.prdct_id === curitem.prdct_id
                        && targetobj.opt_id === curitem.opt_id)
                })

                // console.log("idx ======> " + idx)

                if (idx >= 0) {
                    state.cartProdList[idx] = curitem;
                } else {
                    state.cartProdList.push(curitem);
                }
            });

            // update 처리 
            state.updateStatus = !state.updateStatus;

            return ({
                ...state,
                getcode: payload.code,
            })
        },
        [SYNC_CART_SUCCESS]: (state, { payload }) => {
            // update 처리 
            state.updateStatus = !state.updateStatus;

            return ({
                ...state,
                synccode: payload.code,
                cartProdList: payload.data
            })
        },
        [SYNC_CART_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state
            })
        },
        [SET_USER_CART_PROD]: (state, { payload: arrAddItems }) => {

            // 기존에 브랜드 아이디가 없는 항목은 삭제 
            remove(state.cartProdList, (curitem) => {
                return curitem.brnd_id === 0;
            })

            arrAddItems.map((curitem) => {

                // 추가할 아이템이 이미 추가 되어 있는지 확인
                let objIdx = findIndex(state.cartProdList, (obj) => {
                    return (obj.prdct_id === curitem.prdct_id && obj.opt_id === curitem.opt_id);
                })

                // console.log(objIdx + " : " + JSON.stringify(arrAddItems));
                // 신규 추가 의 경우 
                if (objIdx === -1) {
                    if (curitem.brnd_id !== 0
                        && curitem.brnd_nm !== null
                        && curitem.brnd_nm.length > 0) {
                        state.cartProdList.push(curitem);
                    }

                } else {
                    // 갯수 증가 시키고 전체 금액 계산 
                    let qty = ++state.cartProdList[objIdx].qty;
                    let price = state.cartProdList[objIdx].es_opt_pirce;
                    state.cartProdList[objIdx].es_prdct_price = (price * qty);
                }

                return null;
            })

            // update 처리 
            state.updateStatus = !state.updateStatus;

            return ({ ...state });
        },
        [REMOVE_USER_CART_PROD]: (state, { payload: removeItem }) => {

            // 옵션 아이디가 unique 하므로 비교하여 삭제 / 옵션이 없는 경우를 위해 상품 아이디도 같이 비교 
            remove(state.cartProdList, (obj) => {
                return (obj.prdct_id === removeItem.prdct_id && obj.opt_id === removeItem.opt_id);
            })

            // update 처리 
            state.updateStatus = !state.updateStatus;

            return ({ ...state });
        },
        [REMOVE_USER_CART_PROD_BRAND]: (state, { payload: removeBrandId }) => {

            // 브랜드 기준 항목 삭제
            remove(state.cartProdList, (obj) => {
                return obj.brnd_id === (removeBrandId * 1);
            })

            // update 처리 
            state.updateStatus = !state.updateStatus;
            return ({ ...state });
        },
        [UPDATE_USER_CART_PROD_INFO]: (state, { payload: updateItem }) => {

            // 아이템 찾기 
            let objIdx = findIndex(state.cartProdList, (obj) => {
                return (obj.opt_id === updateItem.opt_id);
            })

            state.updateStatus = !state.updateStatus;

            if (objIdx !== -1) {
                state.cartProdList[objIdx] = updateItem;
            }

            return ({ ...state });
        },
        [SET_USER_CART_PROD_LIST]: (state, { payload: cartLst }) => {
            state.updateStatus = !state.updateStatus;

            state.cartProdList = cartLst;

            return ({ ...state });
        },
        [SET_USER_REQ_RROD_LIST]: (state, { payload: reqList }) => {
            state.reqProdList = reqList;
            //console.log('prod = ' + JSON.stringify(reqList))
            return ({ ...state });
        },
    },
    initialState,
);

export default userCartReducer;